import * as React from "react";
import { Container, Box, Typography, Divider, List, ListItem, ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function RefundPage() {
  const { t, i18n } = useTranslation();
  const lastUpdated = new Date().toLocaleDateString(i18n.language);

  return (
    <Container maxWidth="md" sx={{ py: { xs: 4, sm: 6 } }}>
      <Typography variant="h3" sx={{ fontWeight: 700, letterSpacing: -0.5 }}>
        {t("legal.refund.title")}
      </Typography>
      <Typography sx={{ color: "text.secondary", mt: 1 }}>
        {t("legal.common.lastUpdated")} {lastUpdated}
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography>
          {t("legal.refund.intro")}
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {t("legal.refund.sections.cancellation.title")}
        </Typography>
        <Typography>
          {t("legal.refund.sections.cancellation.body")}
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {t("legal.refund.sections.refunds.title")}
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary={t("legal.refund.sections.refunds.bullets.nonRefundable")} />
          </ListItem>
          <ListItem>
            <ListItemText primary={t("legal.refund.sections.refunds.bullets.errorCharge")} />
          </ListItem>
        </List>

        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {t("legal.refund.sections.contact.title")}
        </Typography>
        <Typography>
          {t("legal.common.contact", { email: "contact@kehilati.com" })}
        </Typography>
      </Box>
    </Container>
  );
}

